import React from "react";

const Alert = ({ type, text }) => {
  return (
    <div className={`alert ${type || ""}`}>
      <div className="alert__box">
        <span>{type}</span>
        {text}
      </div>
    </div>
  );
};

export default Alert;
